export default {
    contact_type: {
        registrant: 'Registrant Contacts',
        tech: 'Technical Contacts',
        admin: 'Administrator Contacts',
        auxBilling: 'Billing Contacts',
    },
};
